import {
  getNotificationsRef,
  readNotification,
  readAllNotifications
} from "db/notification";
import { showAlertAction } from "./ui";

export const FETCH_NOTIFICATIONS = "fetch notifications";
export const CHECK_READ_NOTIFICATION = "check read notification";
export const CHECK_READ_ALL_NOTIFICATIONS = "check read all notifications";



export const fetchNotificationsAction = () => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  return getNotificationsRef(uid)
    .onSnapshot((colSnap => {
      dispatch({
        type: FETCH_NOTIFICATIONS,
        payload: colSnap.docs
      });
    }), e => {
      console.error("Failed to get notifications: ", e);
      dispatch(showAlertAction({
        message: "알림 리스트를 가져오는데 문제가 있습니다. 잠시후 다시 시도해주세요",
        color: 'danger',
      }));
    });
}

export const checkReadNotificationAction = (notification_id) => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  return readNotification(uid, notification_id);
}

export const checkReadAllNotificationsAction = () => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  return readAllNotifications(uid);
}